import React from 'react';
import WaybillQueryContent from './../../waybill/query/WaybillQueryContent';

function WaybillQuery() {
  return <WaybillQueryContent saleReport />;
}

export default WaybillQuery;
